import {useSnackbar} from 'notistack';
import {forwardRef, useImperativeHandle} from 'react';

import API from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';

export interface ToggleEventDelayProps {
  onSubmitted?: () => void;
}

export interface ToggleEventDelayRef {
  submit: (pk: number, status: string) => void;
}

export const AMSEModuleItemToggleEventDelay = forwardRef<
  ToggleEventDelayRef,
  React.PropsWithChildren<ToggleEventDelayProps>
>(({onSubmitted}, ref) => {
  const {enqueueSnackbar} = useSnackbar();

  useImperativeHandle(ref, () => ({
    submit: (pk, status) => submitData(pk, status),
  }));

  const submitData = async (pk: number, status: string) => {
    try {
      const endpoint = `${apiBaseUrl}/ams/emodule/${pk}/event-delay/1`;
      const data = {
        enable: status,
      };
      const response = await API.patch(endpoint, data);
      const message = response?.data?.message ?? 'done';
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.();
    } catch (error: any) {
      const message = error?.response?.data?.message ?? 'There is an error';
      enqueueSnackbar(message, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
  };

  return null;
});
